import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ShopInfoEdit.css';

function CustomCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCategories = () => {
    axios.get('/api/merchant/custom-categories', {
      headers: { 'x-telegram-init-data': window.Telegram.WebApp.initData }
    })
      .then(res => {
        setCategories(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        alert('获取分类失败');
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const addCategory = () => {
    setCategories([...categories, { name: '', sort_order: categories.length }]);
  };

  const updateCategory = (index, name) => {
    const updated = [...categories];
    updated[index].name = name;
    setCategories(updated);
  };

  const removeCategory = (index) => {
    const updated = categories.filter((_, i) => i !== index);
    setCategories(updated);
  };

  const saveCategories = () => {
    const payload = categories.filter(cat => cat.name.trim() !== '');
    axios.post('/api/merchant/custom-categories', { categories: payload }, {
      headers: { 'x-telegram-init-data': window.Telegram.WebApp.initData }
    })
      .then(() => {
        alert('保存成功');
        fetchCategories();
      })
      .catch(err => {
        console.error(err);
        alert('保存失败');
      });
  };

  if (loading) return <div className="shop-info-edit-container" style={{ textAlign: 'center', padding: '40px' }}>加载中...</div>;

  return (
    <div className="shop-info-edit-container">
      <h2>自定义分类管理</h2>
      <p>设置您店铺的菜品分类，如“湘菜”、“川菜”、“主食”等，顾客可按分类筛选。</p>
      <button className="submit-btn" onClick={addCategory} style={{ marginBottom: 20 }}>+ 添加分类</button>
      <div className="shop-info-form">
        {categories.map((cat, idx) => (
          <div key={idx} className="form-group" style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <input
              type="text"
              value={cat.name}
              onChange={e => updateCategory(idx, e.target.value)}
              placeholder="分类名称"
              style={{ flex: 1 }}
            />
            <button className="upload-button" onClick={() => removeCategory(idx)}>删除</button>
          </div>
        ))}
        <button className="submit-btn" onClick={saveCategories}>保存分类</button>
      </div>
    </div>
  );
}

export default CustomCategories;